module.exports = __webpack_public_path__ + "img/9_natalie_h.5de15529.png";